import { render } from "./tableHead.vue?vue&type=template&id=4626b126&ts=true"
import script from "./tableHead.vue?vue&type=script&lang=ts"
export * from "./tableHead.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__